var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_flash",
    "data-name": "vuesax/linear/flash",
    transform: "translate(-428 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flash",
    transform: "translate(428 316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.083,8.931H3.53v5.7c0,1.33.72,1.6,1.6.6l5.993-6.808c.736-.831.427-1.52-.689-1.52H7.987V1.2c0-1.33-.72-1.6-1.6-.6L.395,7.411C-.334,8.25-.025,8.931,1.083,8.931Z",
    transform: "translate(3.738 1.583)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H19V19H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.fcae18719692c7d4808f521b59ff0252.svg";
export { ForwardRef as ReactComponent };